module.exports = __webpack_public_path__ + "img/card-parcel-101.ff7070b.webp";